<div (click)="onClose()"
     [ngStyle]="!isMobile && {'padding.%': 5}"
     class="alert-box">
  <div role="alert">
    <div class="header-icon-container">
      <button (click)="onClose()" [attr.aria-label]="'accessibility.close' | translate"
              class="header-img clear-button">
        <img alt="" loading="lazy"
             src="assets/scalableVectorGraphics/close.svg" />
      </button>
    </div>
    <br>
    <p [ngStyle]="!isMobile && {'font-size': '1.2rem'}" class="text-center">{{ "shared.areYouSure" | translate }}</p>

    <br>
    <button (click)="stay()"
            [ngClass]="{'w-30': !isMobile}"
            class="btn btn-outline-light black-outline"
            type="button">{{ "shared.noContinue" | translate }}
    </button>
    <br>
    <button (click)="logout()"
            [ngClass]="{'w-30': !isMobile}"
            class="btn btn-outline-light black-outline"
            type="button">{{ "shared.yesLeave" | translate }}
    </button>

  </div>
</div>
